"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a="undefined"!=typeof window?window:{};exports.global=a
//# sourceMappingURL=global.js.map
